import React from "react";
import { Row, Container } from "react-bootstrap";
import PropTypes from 'prop-types';
import { makeStyles } from "@material-ui/core/styles";

import './CallToAction.scss';

export default function CallToAction(props) {

  const useStyles = makeStyles(theme => ({
    backgroundMain: {
      backgroundColor: theme.palette.primary.main,
    },
  }));

  const classes = useStyles();

  return (
    <Row className={`${classes.backgroundMain} call-to-action-wrapper px-2`}>
      <Container className="call-to-action-container">
        <Row className="d-flex flex-column justify-content-center align-items-center">
          <h3 className={props.subtitle ? "title has-subtitle" : "title"}>{props.title}</h3>
          {props.subtitle && <p className="subtitle">{props.subtitle}</p>}
          {props.actions}
        </Row>
      </Container>
    </Row>
  );
}

CallToAction.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  actions: PropTypes.element.isRequired,
}


// WEBPACK FOOTER //
// ./src/components/PolicyReview/CallToAction/CallToAction.js